export const liquidPixelResolutionMappings = {
    // miniature, smaller resolutions
    34: ['res[s]', 'call=url[file:/product/miniature]'],
    72: ['res[l]', 'call=url[file:/product/miniature]'],
    126: ['res[q]', 'call=url[file:/product/miniature]'],
    // main, medium resolutions
    264: ['res[z]', 'call=url[file:/product/main]'],
    396: ['res[y]', 'call=url[file:/product/main]'],
    564: ['res[w]', 'call=url[file:/product/main]'],
    657: ['res[s]', 'call=url[file:/product/main]'],
    // fullscreen, large resolutions
    1536: ['res[m]', 'call=url[file:/product/fullscreen]'],
    2160: ['res[l]', 'call=url[file:/product/fullscreen]'],
};
export const sizes = Object.keys(liquidPixelResolutionMappings);
export const findResolutionIndex = (res, call) => {
    for (let i = 0; i < sizes.length; i += 1) {
        const size = sizes[i];
        const [currentRes, currentCall] = liquidPixelResolutionMappings[size];
        if (currentRes === res && currentCall === call) {
            return i;
        }
    }
    return undefined;
};
export const wrapProductImageSrc = (src, closestWidth, useDevPrefixedUrl) => {
    let mappedSrc = decodeURIComponent(src);
    const envString = useDevPrefixedUrl ? 'dev' : 'prod';
    if (!mappedSrc.includes('source[')) {
        mappedSrc = `https://lp2.hm.com/hmgoep${envString}?set=source[${mappedSrc}],origin[dam],category[],type[],res[m],hmver[1]&call=url[file:/product/main]`;
    }
    if (useDevPrefixedUrl && mappedSrc.indexOf('hmgoepprod') !== -1) {
        mappedSrc = mappedSrc.replace(/hmgoepprod/, 'hmgoepdev');
    }
    if (mappedSrc.indexOf('portfolio') !== -1) {
        mappedSrc = mappedSrc.replace('ImageVersion', 'target[hm.com],ImageVersion');
    }
    if (!mappedSrc.includes('res[')) {
        mappedSrc = mappedSrc.replace('&hmver', `,res[m]&hmver`).replace(',hmver', `,res[m],hmver`);
    }
    return mappedSrc
        .replace(/res\[.\]/, liquidPixelResolutionMappings[closestWidth][0])
        .replace(/call=url\[[^\]]*\]/, liquidPixelResolutionMappings[closestWidth][1]);
};
//# sourceMappingURL=productImageMappings.js.map